import { render, staticRenderFns } from "./UserScientificDegreeInfo.vue?vue&type=template&id=3e9f7d42&"
import script from "./UserScientificDegreeInfo.vue?vue&type=script&lang=js&"
export * from "./UserScientificDegreeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports